import { shared } from '@tig-dpqa-cloud/contract-backend-common';
import { z } from 'zod';
import { UserIdSchema, UserPermissionsSchema } from './users-get';

export const UsersUpdateResponse = z.object({
  id: UserIdSchema,
  tenantId: shared.TenantId,
  email: z.email(),
  permissions: UserPermissionsSchema,
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  eulaAcceptedAt: z.iso.datetime({ offset: true }).optional(),
});

export type UsersUpdateResponseType = z.infer<typeof UsersUpdateResponse>;
